"use client";
import React, { useState } from "react";
import SendPhone from "../../login/_component/SendPhone";


export default function page() {
    return (
        <>
            <SendPhone />
        </>
    );
}
